import React, { useEffect, useState } from 'react'
import Header from '../../../Components/Header/Header'
import Sidebar from '../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../../../Helper/Loading'
import CommonDashboardWardNameDDL from './CommonDashboardWardNameDDL'
import GardenMaintainanceComp from './GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceComp'


export const ElectricalDashboard = () => {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user

    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 1,
        Label: "Select Ward",
    })
    const [Countdata, setCountdata] = useState({})
    // const [FinancialYearID, setFinancialYear] = useState('')
    const [HeaderFinancialYear, setHeaderFinancialYear] = useState('')
    const [HeaderMonthID, setHeaderMonthID] = useState('')
    const [MonthID, setMonthID] = useState('')
    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [ActiveBtn, SetActiveBtn] = useState(RoleID == 2 ? "Electrical" : '')

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleGetFinancialYearID = (FinancialYear, Month) => {
        setHeaderMonthID(Month)
        setHeaderFinancialYear(FinancialYear)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetCount
        }

        // dispatch(STPDashboardMainCountDataAPI({ data }))

    }, [Ward.ID, Month.ID, year.ID])

    const { STPDashboardCountData, isLoading } = useSelector(state => state.STPDashboardMainCountData)

    const handleGetCount = (data) => {
        // console.log("data", data)
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }




    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="main-content side_shrink position-relative border-radius-lg "></div> */}
            <div>
                <Header
                    DashboardHeading="Water Supply Maintenance"
                    setYearValue={setYearValue}
                    setMonthValue={setMonthValue}
                    FinancialYear={FinancialYear}
                    setFinancialYear={setFinancialYear}
                    Month={Month}
                    setMonth={setMonth}
                    setYearLabel={setYearLabel}
                    setMonthLabel={setMonthLabel}
                    setWardValue={setWardValue}
                    setWardLabel={setWardLabel}
                    DashboardName={DashboardName}
                    HideYearMonthDDL='Dashboard'
                    Name="Electrical"
                />
                {/* <Sidebar active="dashboard" /> */}
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} listActive="gardennn" active={`${RoleID == "43" ? "ElectricalDashboard" : ""}`} />
                    <div className="content1 content">

                        {/* <div id="page-content-wrapper"> */}
                        {/* <div className="pcoded-main-container main-row">
                        <div className="pcoded-content "> */}
                        {/* <!-- [ breadcrumb ] start --> */}
                        <CommonDashboardWardNameDDL
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                        />

                    {
                        RoleID == '1' &&
                        <GardenMaintainanceComp />
                    }
                    </div>
                    {/* <!-- [ Main Content ] end --> */}
                </div>
            </div>
        </>


    )
}
